import type { AbsenceType } from "../api/client";

export const ABSENCE_TYPE_LABEL: Record<AbsenceType, string> = {
  // Подтипы отпуска: поведение одинаковое, разница — в кадровом оформлении
  // (HR по типу понимает, какой приказ готовить). Legacy-код vacation
  // остаётся за плановым отпуском (записи не мигрируются).
  vacation: "Плановый отпуск",
  vacation_unpaid: "Отпуск за свой счёт",
  // US-78: 3 подтипа отгула вместо общего «Отгул».
  day_off_vacation: "Отгул в счёт отпуска",
  day_off_weekend: "Отгул за работу в выходные",
  day_off_unpaid: "Отгул за свой счёт",
  sick_leave: "Больничный",
};

export const ABSENCE_TYPE_OPTIONS: { value: AbsenceType; label: string }[] = [
  { value: "vacation", label: ABSENCE_TYPE_LABEL.vacation },
  { value: "vacation_unpaid", label: ABSENCE_TYPE_LABEL.vacation_unpaid },
  { value: "day_off_vacation", label: ABSENCE_TYPE_LABEL.day_off_vacation },
  { value: "day_off_weekend", label: ABSENCE_TYPE_LABEL.day_off_weekend },
  { value: "day_off_unpaid", label: ABSENCE_TYPE_LABEL.day_off_unpaid },
  { value: "sick_leave", label: ABSENCE_TYPE_LABEL.sick_leave },
];

/**
 * Approximate working-days count between two dates inclusive,
 * counting only Mon-Fri. Server is source of truth — this is a UX preview only.
 */
export function approxWorkingDays(start: Date | null, end: Date | null): number {
  if (!start || !end) return 0;
  const a = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const b = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  if (b < a) return 0;
  let count = 0;
  const cursor = new Date(a);
  while (cursor <= b) {
    const dow = cursor.getDay(); // 0=Sun, 6=Sat
    if (dow !== 0 && dow !== 6) count += 1;
    cursor.setDate(cursor.getDate() + 1);
  }
  return count;
}
